import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "sv2-takeover"
}
const _hoisted_2 = {
  key: 0,
  class: "sv2-progress"
}
const _hoisted_3 = {
  key: 1,
  class: "sv2-mobile-banner"
}
const _hoisted_4 = { class: "sv2-mobile-banner__icon" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "sv2-mobile-banner__text" }
const _hoisted_7 = { class: "sv2-form-pane" }
const _hoisted_8 = { class: "sv2-visual-pane" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_share_method_screen = _resolveComponent("share-method-screen")!
  const _component_ph_buildings = _resolveComponent("ph-buildings")!
  const _component_ph_lock = _resolveComponent("ph-lock")!
  const _component_ph_envelope_open = _resolveComponent("ph-envelope-open")!
  const _component_ph_broadcast = _resolveComponent("ph-broadcast")!
  const _component_ph_paper_plane_tilt = _resolveComponent("ph-paper-plane-tilt")!
  const _component_step_about_you = _resolveComponent("step-about-you")!
  const _component_step_organization = _resolveComponent("step-organization")!
  const _component_step_account = _resolveComponent("step-account")!
  const _component_step_verify_email = _resolveComponent("step-verify-email")!
  const _component_step_use_ditto = _resolveComponent("step-use-ditto")!
  const _component_step_tell_admin = _resolveComponent("step-tell-admin")!
  const _component_step_connect_room = _resolveComponent("step-connect-room")!
  const _component_wizard_visual = _resolveComponent("wizard-visual")!

  return (_ctx.slug === _ctx.SHARE_METHOD)
    ? (_openBlock(), _createBlock(_component_share_method_screen, {
        key: 0,
        onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate(_ctx.CONNECT_ROOM)))
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isWizardStep)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "sv2-progress__fill",
                style: _normalizeStyle({ width: _ctx.progressPercent + '%' })
              }, null, 4)
            ]))
          : _createCommentVNode("", true),
        (_ctx.banner)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.banner.logo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.logoLight,
                      alt: "Ditto",
                      width: "18",
                      height: "18"
                    }, null, 8, _hoisted_5))
                  : (_ctx.banner.icon === 'buildings')
                    ? (_openBlock(), _createBlock(_component_ph_buildings, {
                        key: 1,
                        size: 16,
                        weight: "fill"
                      }))
                    : (_ctx.banner.icon === 'lock')
                      ? (_openBlock(), _createBlock(_component_ph_lock, {
                          key: 2,
                          size: 16,
                          weight: "fill"
                        }))
                      : (_ctx.banner.icon === 'envelope-open')
                        ? (_openBlock(), _createBlock(_component_ph_envelope_open, {
                            key: 3,
                            size: 16,
                            weight: "fill"
                          }))
                        : (_ctx.banner.icon === 'broadcast')
                          ? (_openBlock(), _createBlock(_component_ph_broadcast, {
                              key: 4,
                              size: 16,
                              weight: "fill"
                            }))
                          : (_ctx.banner.icon === 'paper-plane-tilt')
                            ? (_openBlock(), _createBlock(_component_ph_paper_plane_tilt, {
                                key: 5,
                                size: 16,
                                weight: "fill"
                              }))
                            : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.banner.text), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createElementBlock("div", {
            key: _ctx.slug,
            class: "sv2-step-enter-active",
            style: {"flex":"1","display":"flex","flex-direction":"column"}
          }, [
            (_ctx.slug === 'about-you')
              ? (_openBlock(), _createBlock(_component_step_about_you, {
                  key: 0,
                  onNext: _ctx.onWizardNext,
                  onEndUserRole: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigate(_ctx.USE_DITTO)))
                }, null, 8, ["onNext"]))
              : (_ctx.slug === 'organization')
                ? (_openBlock(), _createBlock(_component_step_organization, {
                    key: 1,
                    onNext: _ctx.onWizardNext,
                    onBack: _ctx.onWizardBack
                  }, null, 8, ["onNext", "onBack"]))
                : (_ctx.slug === 'account')
                  ? (_openBlock(), _createBlock(_component_step_account, {
                      key: 2,
                      onNext: _ctx.onWizardNext,
                      onBack: _ctx.onWizardBack,
                      onEditEmail: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigate('about-you')))
                    }, null, 8, ["onNext", "onBack"]))
                  : (_ctx.slug === 'verify-email')
                    ? (_openBlock(), _createBlock(_component_step_verify_email, {
                        key: 3,
                        onNext: _ctx.onWizardComplete,
                        onBack: _ctx.onWizardBack
                      }, null, 8, ["onNext", "onBack"]))
                    : (_ctx.slug === _ctx.USE_DITTO)
                      ? (_openBlock(), _createBlock(_component_step_use_ditto, {
                          key: 4,
                          onBack: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigate('about-you'))),
                          onTellAdmin: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigate(_ctx.TELL_ADMIN)))
                        }))
                      : (_ctx.slug === _ctx.TELL_ADMIN)
                        ? (_openBlock(), _createBlock(_component_step_tell_admin, {
                            key: 5,
                            onBack: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigate(_ctx.USE_DITTO)))
                          }))
                        : (_ctx.slug === _ctx.CONNECT_ROOM)
                          ? (_openBlock(), _createBlock(_component_step_connect_room, {
                              key: 6,
                              onConnect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigate(_ctx.SHARE_METHOD))),
                              onBack: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigate(_ctx.USE_DITTO)))
                            }))
                          : _createCommentVNode("", true)
          ]))
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createElementBlock("div", {
            key: _ctx.slug,
            class: "sv2-visual-enter-active",
            style: {"height":"100%","width":"100%"}
          }, [
            _createVNode(_component_wizard_visual, {
              screen: _ctx.slug,
              branded: _ctx.isConnectRoomBranded
            }, null, 8, ["screen", "branded"])
          ]))
        ])
      ]))
}